// extracted by mini-css-extract-plugin
module.exports = {"button":"NativeButton_button__I3Fgs","default":"NativeButton_default__fYCZW","primary":"NativeButton_primary__hYLbq","text":"NativeButton_text__e01pK"};